export enum Status {
  Rejected, // отклоннено
  Approved, // подтвержденно
  InProgress, // на выполненнии
  ManagerRejected, // отклоннено менеджером
  New, // новая
  BloggerReview, // на рассмотрении у блогера
  ManagerCheck, // на проверке у менеджера
  BloggerRejected, // отклоненно блогером
  SendForFix, // на переделывании
  Ban, // в бане
  Draft, // не актуально
}

export enum Category {
  Unknown, // Неизвестный тип
  Food, // Блогер, специализирующийся на еде
  Family, // Семейный блогер
  Sport, // Спортивный блогер
  Healty, // Блогер про здоровый образ жизни

  // Возрастные категории
  Kids, // Детский блог
  Teens, // Для подростков
  Adults, // Взрослая аудитория
  Seniors, // Аудитория старшего возраста

  // Пол
  Male, // Мужская аудитория
  Female, // Женская аудитория

  // Регионы
  Asia, // Азиатский регион
  Europe, // Европейский регион
  NorthAmerica, // Северная Америка
  SouthAmerica, // Южная Америка
  Africa, // Африка
  Oceania, // Океания
  CIS, // Страны СНГ

  // Вид деятельности
  Beauty, // Бьюти-блог
  Travel, // Путешествия
  Education, // Образование
  Fashion, // Мода
  Parenting, // Блог для родителей (мамы/папы)
  Tech, // Технологии и гаджеты
  Gaming, // Игры
  Business, // Бизнес и финансы
  Fitness, // Фитнес
  Art, // Искусство и творчество
  Photography, // Фотография
  Music, // Музыка
  Pet, // Блог о животных
  DIY, // Самоделки и рукоделие
  Auto, // Автомобили
  Politics, // Политика
  Science, // Наука
  News, // Новости и события

  // Для мам (отдельная категория)
  ParentingForMoms, // Блог для мам

  // Развлечения
  Humor, // Юмор и развлечения
  Movies, // Кино и сериалы

  // Экологические темы
  Eco, // Экология и устойчивое развитие
}

export interface IFile {
  fileName: string;
  url: string;
  type: string;
}
